import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'underscore';
import { Divider, mergeClasses } from '@fluentui/react-components';
import { FontEditor } from './font-editor';
import { ColorEditor } from './color-editor';
import { useStyles } from './style';


export const EditVideoStyleView = ({
  i18n,
  palettesState,
  onPalettesUpdated,
  fontsState,
  onFontsUpdated,
  brandKit,
}) => {
  const classes = useStyles();

  const paletteData = useMemo(() => {
    let finalPalettes = [];
    if (!isEmpty(brandKit)) {
      const brandKitPalettes = brandKit.palettes;
      const mappedPalettes = brandKitPalettes.map(palette => ({ ...palette, isBrandKitColor: true }));
      finalPalettes.push(...mappedPalettes);
      palettesState && palettesState.updating && palettesState.updating.forEach((color) => {
        if (!brandKit.palettes.some(c => c.HexCode === color.HexCode)) {
          finalPalettes.push(color);
        }
      });
    } else {
      finalPalettes = palettesState && palettesState.updating ? palettesState.updating : [];
    }
    return finalPalettes;
  }, [palettesState, brandKit]);

  const onChangeFont = useCallback((font) => {
    const newState = {
      ...fontsState,
      updating: { ...fontsState.updating, font },
    };
    onFontsUpdated(newState);
  }, [fontsState, onFontsUpdated]);

  const onChangeWeight = (fontWeight) => {
    const newState = {
      ...fontsState,
      updating: { ...fontsState.updating, fontWeight },
    };
    onFontsUpdated(newState);
  };

  return (
    <div className={mergeClasses(classes.styleGuideContainer, 'edit-video-style-view')} >
      <div className={classes.styleGuideTitle}>{i18n.getString(_TL_('Edit your video\'s style '))}</div>
      <ColorEditor
        i18n={i18n}
        palettesState={palettesState}
        onPalettesUpdated={onPalettesUpdated}
        brandKit={brandKit}
        paletteData={paletteData}
      />
      <Divider appearance="strong" className={classes.textDivider} />
      <FontEditor
        i18n={i18n}
        onChangeFont={onChangeFont}
        onChangeWeight={onChangeWeight}
        fontsState={fontsState}
      />
    </div>
  );
};

EditVideoStyleView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  palettesState: PropTypes.shape({
    updating: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string,
      Colors: PropTypes.arrayOf(PropTypes.string),
    })),
  }).isRequired,
  onPalettesUpdated: PropTypes.func.isRequired,
  fontsState: PropTypes.shape({
    updating: PropTypes.shape({
      font: PropTypes.string,
      fontWeight: PropTypes.string,
    }),
  }).isRequired,
  onFontsUpdated: PropTypes.func.isRequired,
  brandKit: PropTypes.shape({
    palettes: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string,
      Colors: PropTypes.arrayOf(PropTypes.string),
    })),
  }).isRequired,
};

EditVideoStyleView.defaultProps = {
};
